<template>
  <div class="instagram-analytics-public">
    <div class="loading-bar" v-if="loading"></div>
    <div class="loading-bar-hide" v-else></div>
    <div v-if="!campaign || !campaign.id"></div>
    <div class="instagram-analytics-public-container" v-else>
      <InstagramAnalyticsPublicHeader class="mb-x2"></InstagramAnalyticsPublicHeader>
      <InstagramAnalyticsPublicFilter class="mb-x2"></InstagramAnalyticsPublicFilter>
      <InstagramAnalyticsPublicSummary class="mb-x2"></InstagramAnalyticsPublicSummary>
      <InstagramAnalyticsPublicCampaign></InstagramAnalyticsPublicCampaign>
    </div>
  </div>
</template>

<script lang="ts">
import moment from 'moment'
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import InstagramAnalyticsPublicCampaign from '@/client/features/instagram_analytics_public/instagram_analytics_public_campaign'
import InstagramAnalyticsPublicFilter from '@/client/features/instagram_analytics_public/instagram_analytics_public_filter'
import InstagramAnalyticsPublicHeader from '@/client/features/instagram_analytics_public/instagram_analytics_public_header'
import InstagramAnalyticsPublicSummary from '@/client/features/instagram_analytics_public/instagram_analytics_public_summary'
import { useInstagramAnalyticsPublicStore } from '@/client/store/useInstagramAnalyticsPublicStore'
import { getAnalyticsDefaultPeriod } from '@/common/utils/analytics_period'

export default defineComponent({
  components: {
    InstagramAnalyticsPublicCampaign,
    InstagramAnalyticsPublicFilter,
    InstagramAnalyticsPublicHeader,
    InstagramAnalyticsPublicSummary
  },
  computed: {
    ...mapState(useInstagramAnalyticsPublicStore, {
      params: state => state.params,
      campaign: state => state.campaign,
      loading: state => state.loading
    })
  },
  async created() {
    const hash = this.$route.query.hash as string

    if (!hash) {
      return
    }

    const params = { hash }

    this.setParams(params)

    await this.fetchCampaign()
    await this.fetchPrizes()

    if (!this.campaign || !this.campaign.id) {
      return
    }

    const [startDatetime, endDatetime] = getAnalyticsDefaultPeriod(
      this.campaign.startDatetime,
      this.campaign.endDatetime
    )

    this.setParams({
      startDatetime: moment(startDatetime).format('YYYY-MM-DD'),
      endDatetime: moment(endDatetime).format('YYYY-MM-DD')
    })

    await this.fetchCampaignAnalytics()
  },
  methods: {
    ...mapActions(useInstagramAnalyticsPublicStore, [
      'fetchCampaignAnalytics',
      'fetchCampaign',
      'fetchPrizes',
      'setParams'
    ])
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.instagram-analytics-public-container {
  max-width: $max-content-width;
  padding: $spacing-unit * 2;
  margin: 0 auto;
  background-color: #fff;
}
</style>
